// src/serviceWorkerRegistration.js

// 注册 SW
export function register() {
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js')
          .then(reg => {
            console.log('SW 注册成功，scope:', reg.scope);
          })
          .catch(err => {
            console.error('SW 注册失败:', err);
          });
      });
    }
}

// 注销 SW（可选，用于开发或回滚）
export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(r => r.unregister());
    });
  }
}
  